export default function EditSolidIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.9 6.858l4.242 4.243-9.9 9.9H3v-4.244l9.9-9.9v.001zm1.414-1.414l2.121-2.122a1 1 0 011.414 0l2.829 2.83a1 1 0 010 1.413l-2.122 2.121-4.242-4.242z"
        fill={props.fill}
      />
    </svg>
  )
}